module.exports = __webpack_public_path__ + "img/foto_blur_tuin_h400.5703ebaa.jpg";